import { __assign } from "tslib";
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import TierProductCardDumbDesktop from './TierProductCardDumbDesktop';
import TierProductCardDumbMobile from './TierProductCardDumbMobile';
var TierProductCardDumb = function (props) {
    var isMobile = useContext(MobileContext);
    return isMobile ? (React.createElement(TierProductCardDumbMobile, __assign({}, props))) : (React.createElement(TierProductCardDumbDesktop, __assign({}, props)));
};
TierProductCardDumb.displayName = 'TierProductCardDumb';
export default TierProductCardDumb;
//# sourceMappingURL=TierProductCardDumb.js.map